import {gatewayUrl} from "config";
import {postRequest} from "redux-request-middleware";
export enum Actions {
  REQUEST_LOG_LOCATION = "REQUEST_LOG_LOCATION",
}

export const pingLocation = (longitude, latitude , userID) => {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_LOG_LOCATION,
                "location-service/location",
                {longitude, latitude},
                false,
                null,
                null,
                gatewayUrl,
            ),
        );
    };
}

